import React, { useContext } from 'react';
import FallbackAvatar from './FallbackAvatar.js';
import { Image } from 'wix-rich-content-ui-components';
import { RicosContext } from 'ricos-context';

function VoterAvatar(props) {
  const { className, src, memberInfo, size } = props;
  const { t } = useContext(RicosContext);
  return src ? /* @__PURE__ */ React.createElement(
    Image,
    {
      uri: src,
      displayMode: "fill",
      alt: memberInfo.name || t("Polls_Plugin_User_Avatar_Alt"),
      height: size.height,
      width: size.width,
      containerProps: {
        className,
        style: size
      }
    }
  ) : /* @__PURE__ */ React.createElement(FallbackAvatar, { className });
}

export { VoterAvatar as default };
//# sourceMappingURL=VoterAvatar.js.map
